import React, { useEffect, useState } from "react"
import styles from "./index.module.less"
import { PlayArrow } from "@material-ui/icons"
import MediaShow from "./MediaShow"
import { downloadFileLink } from "@/apis/announcementApi"

const MediaPreview = ({ type, src, s3Path, gc, style }) => {
  const [mediaOpen, setMediaOpen] = useState(false)
  const [source, setSource] = useState()

  useEffect(() => {
    if (src) setSource(src)
  }, [src])

  useEffect(() => {
    if (s3Path) {
      downloadFileLink(s3Path).then(({ download_link }) => {
        setSource(download_link)
      })
    }
  }, [s3Path])

  return (
    <div>
      {type === "image" && (
        <img src={source} className={styles.image} onClick={() => setMediaOpen(true)} style={style} />
      )}
      {type === "video" && (
        <div className={styles.videoWrapper} onClick={() => setMediaOpen(true)} style={style}>
          <video src={source} className={styles.video} style={style} />
          <div className={styles.playButtonWrapper}>
            <PlayArrow fontSize="large" className={styles.playButton} />
          </div>
        </div>
      )}
      <MediaShow open={mediaOpen} onClose={() => setMediaOpen(false)} src={source} type={type} />
    </div>
  )
}

export default MediaPreview